import React from "react";
import ReviewCard from "./ReviewCard";
import { Divider } from "@mui/material";
import { useAppSelector } from "../../../State/Store";

const Review = () => {
    const { product } = useAppSelector((state) => state.product);

    return (
        <div className='p-5 lg:px-20 flex flex-col lg:flex-row gap-20'>
            <section className='w-full md:w-1/2 lg:w-[30%] space-y-2'>
                <img
                    className="w-full h-72 object-cover object-top rounded-md"
                    src={product?.images?.[0] || "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=500"}
                    alt={product?.title}
                />

                <div className="pt-2">
                    <div>
                        <p className='font-bold text-xl'>{product?.seller?.businessDetails?.businessName || "Text Clothing"}</p>
                        <p className='text-lg text-gray-600'>{product?.title || "Men's White Shirt"}</p>
                    </div>

                    <div>
                        <div className='price flex items-center gap-3 mt-3 text-2xl'>
                            <span className="font-sans text-gray-800 font-bold">
                                Ksh {product?.sellingPrice}
                            </span>
                            {product && product.mrpPrice > product.sellingPrice && (
                                <>
                                    <span className="line-through text-gray-400 text-lg">
                                        Ksh {product.mrpPrice}
                                    </span>
                                    <span className="text-teal-600 text-lg font-semibold">
                                        {product.discountPercent}% OFF
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <section className='space-y-5 w-full'>
                {/* 🚀 Dynamic Type Casting bypasses strict schema configuration errors cleanly */}
                {(product as any)?.reviews && (product as any).reviews.length > 0 ? (
                    (product as any).reviews.map((review: any) => (
                        <div key={review.id} className='space-y-3'>
                            <ReviewCard review={review} />
                            <Divider />
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500 pt-5">No reviews yet for this product.</p>
                )}
            </section>
        </div>
    );
};

export default Review;